import { render, staticRenderFns } from "./IPDiagnosisReport.vue?vue&type=template&id=5d7b2254&"
import script from "./IPDiagnosisReport.vue?vue&type=script&lang=js&"
export * from "./IPDiagnosisReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports